export class GlobalResponseObject {
    status: boolean;
    statusCode?: number;
    intlCode: number;
    internalMessage: string;
    constructor(status: boolean, intlCode: number, internalMessage: string){
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
    }
}

